
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.2644 7.20521C12.9908 4.9316 9.30451 4.9316 7.03089 7.20521C4.75728 9.47882 4.75728 13.1651 7.03089 15.4387C9.30451 17.7123 12.9908 17.7123 15.2644 15.4387C17.538 13.1651 17.538 9.47882 15.2644 7.20521ZM5.61668 5.791C8.67134 2.73633 13.6239 2.73633 16.6786 5.791C19.4332 8.54565 19.7038 12.8437 17.4902 15.9016L20.3815 18.7929C20.7721 19.1834 20.7721 19.8166 20.3815 20.2071C19.991 20.5976 19.3578 20.5976 18.9673 20.2071L16.1205 17.3603C13.0478 19.897 8.49163 19.7279 5.61668 16.8529C2.56202 13.7982 2.56202 8.84566 5.61668 5.791Z","fill":"#16171F"}})])
          )
        }
      }
    